// Central brand config \u2014 swap BRAND to rebrand the whole store in one place.
export const BRAND = "BEAMLUX";
export const BRAND_SUFFIX = "Projection Studio";
